import Modal from './modal.vue';
export default Modal;


// WEBPACK FOOTER //
// ./src/components/modal/index.js